export const TOKEN = 'token'
export const REFRESH_TOKEN = 'refresh_token'
export const REDIRECT_AFTER_AUTH = 'redirectToAfterLogin'
